<template>
    <v-layout column>
        <v-toolbar class="text-h5 mb-3">
            <v-icon class="mr-3">receipt</v-icon>
            Conversion Review
        </v-toolbar>
        <v-layout align-start>
            <lead-info
                :currentStep="currentStep"
                :unitFeatures="unitFeatures"
                :convertedReservation="convertedReservation"
                :lead="lead"
                @toOptions="toOptions"
                @toUnitSelect="toUnitSelect"
            />
        </v-layout>
        <v-layout class="mt-1 mb-4 subheading" v-if="currentStep === 3">
            <v-btn
                data-testid="return-reservations-options-btn"
                class="return-reservations-options-btn mr-4"
                @click="toOptions"
            >
                <v-icon class="mr-3" id="convert-options-return-two">shopping_cart</v-icon>
                Return to Reservation Options
            </v-btn>
            <v-btn
                data-testid="return-select-unit-btn"
                class="return-select-unit-btn"
                @click="toUnitSelect"
            >
                <v-icon class="mr-3" id="convert-select-return">domain</v-icon>
                Return to Select Unit
            </v-btn>
        </v-layout>
        <v-flex class="subheading mx-2 mb-3">
            Please review all details of this reservation, and adivse the customer of any changes from their original
            lead. If needed, you may navigate to back to Reservation Options or Select Unit with the above button.
            If everything looks correct, click "Submit" to process this reservation.
        </v-flex>
    </v-layout>
</template>

<script>
import LeadInfo from "@/components/convert-lead/partials/LeadInfo";

export default {
  props: ["currentStep", "unitFeatures", "convertedReservation", "lead"],

  methods: {
    toOptions() {
      this.$emit("toOptions");
    },

    toUnitSelect() {
      this.$emit("toUnitSelect");
    }
  },

  components: {
    LeadInfo
  }
};
</script>
